import { render, staticRenderFns } from "./EquityFreeze.vue?vue&type=template&id=13327dce"
import script from "./EquityFreeze.vue?vue&type=script&lang=js"
export * from "./EquityFreeze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports